import {Component, Input} from '@angular/core';
import {ReporteServices} from '../../services/reporte.services';
import {Color, Label} from 'ng2-charts';
import {ChartDataSets, ChartOptions, ChartType} from 'chart.js';
import {CurrencyPipe} from '@angular/common';

@Component({
  selector: 'ventas-widget',
  templateUrl: '../../templates/widgets/ventas.widget.template.html'
})
export class VentasWidgetComponent {

  public metaGeneral: number = 0;

  @Input()
  nombreParticipante:string = "Colaboradores";

  // options
  view: any[] = [800, 450];
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = false;

  showYAxisLabel = true;
  xAxisLabel = '';
  yAxisLabel = 'En Pesos';
  timeline = true;

  colorScheme = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  };

  public mostrar: boolean = false;
  public datosGrafica: any[] = [];

  public barChartLabels: Label[] = [];

  public barChartData: ChartDataSets[] = [
    {data: [], label: '', type: 'line', fill: false, backgroundColor:"rgba(0,0,0,0)"},
    {data: [], fill: false, label: 'Cumplimiento'}

  ];

  // public barChartColors: Color[] = [
  //   { backgroundColor: 'purple' },
  //   { backgroundColor: 'brown' },
  // ];
  public barChartColors: Color[] = [];
  public barChartOptions: ChartOptions = {
    responsive: true,
    // We use these empty structures as placeholders for dynamic theming.
    scales: {xAxes: [{}], yAxes: [{}]},
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
        formatter: (value, ctx) => {

          const label = ctx.chart.data.datasets[0].data[ctx.dataIndex] + "%";
          // console.log(ctx.chart.data);
          return label;
        },
        font:{
          size:0
        }
      }
    }
  };

  public barChartType: ChartType = 'bar';
  public barChartLegend = true;


  constructor(private rs: ReporteServices, private cp:CurrencyPipe) {
  }

  consultar(entidad: number, idEntidad: any, fecha1: string, fecha2: string) {

    this.mostrar = false;

    this.datosGrafica = [];
    this.barChartLabels = [];

    let valoresGrafica = [];
    let valoresCum = [];
    let coloresBarra: any[] = [];

    this.rs.devolverReporteVentas(entidad, idEntidad, fecha1, fecha2).subscribe(d => {

      if (d.data.reporteVentas) {
        let data = JSON.parse(d.data.reporteVentas);

        this.metaGeneral = data.metaEntidad;


        for (let inf of data.infMetaPar) {

          let cumplimiento:number = 0;

          if (inf.meta > 0)
            cumplimiento = inf.ventas / inf.meta * 100;
          this.barChartLabels.push(inf.nombres);

          // console.log(cumplimiento);
          // console.log(cumplimiento.toFixed(3));

          cumplimiento = parseFloat(cumplimiento.toFixed(2));

          valoresGrafica.push(cumplimiento);
          // coloresBarra.push({backgroundColor: DevolverColorFriedman(cumplimiento)});
          coloresBarra.push(DevolverColorFriedman(cumplimiento));
          valoresCum.push(100);


          // console.log(`la venta es de ${inf.ventas}, la meta es de ${inf.meta}, el cumplimiento es de ${inf.ventas / inf.meta})`);


          this.datosGrafica.push({
            'name': inf.nombres,
            'series': [
              {
                'name': 'Meta',
                'value': inf.meta
              },
              {
                'name': 'Ventas',
                'value': inf.ventas
              }
              // {
              //   "name":"Cumplimiento",
              //   "value":cumplimiento
              // }
            ]
          });
        }

        this.barChartData[1].data = valoresGrafica;
        this.barChartData[1].backgroundColor = [...coloresBarra];
        this.barChartData[0].data = valoresCum;
        // this.barChartColors = [...coloresBarra];




        this.mostrar = true;

      }
    });

  }

  consultandoDatos(){
    this.mostrar = false;

    this.datosGrafica = [];
    this.barChartLabels = [];

  }

  ingresarDatos(reporteVentas:any){

    let valoresGrafica = [];
    let valoresCum = [];
    let coloresBarra: any[] = [];
    let data = JSON.parse(reporteVentas);

    this.metaGeneral = data.metaEntidad;


    for (let inf of data.infMetaPar) {

      let cumplimiento:number = 0;

      if (inf.meta > 0)
        cumplimiento = inf.ventas / inf.meta * 100;
      this.barChartLabels.push(inf.nombres);

      // console.log(cumplimiento);
      // console.log(cumplimiento.toFixed(3));

      cumplimiento = parseFloat(cumplimiento.toFixed(2));

      valoresGrafica.push(cumplimiento);
      // coloresBarra.push({backgroundColor: DevolverColorFriedman(cumplimiento)});
      coloresBarra.push(DevolverColorFriedman(cumplimiento));
      valoresCum.push(100);


      // console.log(`la venta es de ${inf.ventas}, la meta es de ${inf.meta}, el cumplimiento es de ${inf.ventas / inf.meta})`);


      this.datosGrafica.push({
        'name': inf.nombres,
        'series': [
          {
            'name': 'Meta',
            'value': inf.meta
          },
          {
            'name': 'Ventas',
            'value': inf.ventas
          }
          // {
          //   "name":"Cumplimiento",
          //   "value":cumplimiento
          // }
        ]
      });
    }

    this.barChartData[1].data = valoresGrafica;
    this.barChartData[1].backgroundColor = [...coloresBarra];
    this.barChartData[0].data = valoresCum;
    // this.barChartColors = [...coloresBarra];




    this.mostrar = true;
  }

}

export function DevolverColorFriedman(cumplimiento: number) {
  if (cumplimiento <= 89.99)
    return 'rgb(238,17,0)';
  else if (cumplimiento <= 99.99)
    return 'rgb(0,0,0)';
  else if (cumplimiento <= 109.99)
    return 'rgb(237,238,154)';
  else
    return 'rgb(238,197,22)';
}
